import { render } from "./Deduct.vue?vue&type=template&id=439e5270&scoped=true&ts=true"
import script from "./Deduct.vue?vue&type=script&lang=ts"
export * from "./Deduct.vue?vue&type=script&lang=ts"

import "./Deduct.vue?vue&type=style&index=0&id=439e5270&scoped=true&lang=less"

import exportComponent from "D:\\work\\project\\mobile-mpe\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-439e5270"]])

export default __exports__